// Comandos do agregado Lista — os vocabulários editáveis (funções de
// Funcionário, categorias e unidades de Insumo, tipos de Cliente, Processos,
// Motivos de Retenção e de Divergência). A tela edita uma cópia de trabalho
// e grava a lista inteira no "Salvar", então só há `definir` — com os
// renomeados junto, para o nome novo valer também nos registros.

import type { Snapshot } from "../domain/snapshot.ts";
import { definirLista, listasPadrao, type NomeLista, type Renomeio } from "../domain/listas.ts";
import { assertNunca } from "../lib/assert-nunca.ts";
import { comoObjeto, exigirTexto, lista, texto } from "./_forma.ts";
import type { ContextoComando } from "./lotes.ts";

const NOMES: ReadonlySet<string> = new Set(Object.keys(listasPadrao()));

/**
 * Type predicate em vez de `as NomeLista` no ponto de uso: o `Set` vem de
 * `Object.keys`, que perde os tipos literais, então é aqui que a checagem em
 * tempo de execução e o estreitamento do tipo ficam amarrados (ADR-0013).
 */
function ehNomeLista(v: string): v is NomeLista {
  return NOMES.has(v);
}

export type ComandoLista = {
  tipo: "definir";
  lista: NomeLista;
  valores: string[];
  /** Valores renomeados nesta edição — trocados também nos registros. */
  renomeados?: Renomeio[];
};

export function executarComandoLista(
  snapshot: Snapshot,
  cmd: ComandoLista,
  _ctx: ContextoComando,
): Snapshot {
  switch (cmd.tipo) {
    case "definir":
      return definirLista(snapshot, cmd.lista, cmd.valores, cmd.renomeados ?? []);
    default:
      return assertNunca(cmd.tipo);
  }
}

export function validarComandoLista(valor: unknown): ComandoLista {
  const c = comoObjeto(valor, "Comando de lista");
  if (c.tipo !== "definir") {
    throw new Error(`Tipo de comando de lista desconhecido: ${String(c.tipo)}.`);
  }
  const nome = exigirTexto(c.lista, "lista");
  if (!ehNomeLista(nome)) {
    throw new Error(`Vocabulário desconhecido: ${nome}.`);
  }
  return {
    tipo: "definir",
    lista: nome,
    valores: lista(c.valores, "valores", (x) => texto(x)),
    renomeados:
      c.renomeados == null
        ? []
        : lista(c.renomeados, "renomeados", (x) => {
            const r = comoObjeto(x, "Renomeio");
            return { de: exigirTexto(r.de, "de"), para: exigirTexto(r.para, "para") };
          }),
  };
}
